import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useEmployee from "./useClientMgmt";

const Employee = () => {
  const {
    onAddClient,
    globalFilter,
    setGlobalFilter,
    columns,
    employeeList,
    isEmployeeLoading,
    isMobile,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    isEmployeeRefetching,
    showInActiveConfirmation,
    setShowInActiveConfirmation,
    onActivateDeactivateEmployee,
    selectedUser,
    isUpdateEmployeePending
  } = useEmployee();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Client Management" />
          {isMobile && (
            <Button onClick={onAddClient} className="px-2">
              + Add Client
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          {/* <Button className="bg-white text-g-500 border-g-200 border-1 hover:bg-white">
            <ListFilterIcon />
          </Button> */}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && <Button onClick={onAddClient}>+ Add Client</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isEmployeeLoading || isEmployeeRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={employeeList?.data?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(employeeList?.total / pageSize)}
            totalRecords={employeeList?.total}
            serviceSidePagination={true}
          />
        </>
      )}

      {showInActiveConfirmation && (
        <Dialog
          open={showInActiveConfirmation}
          setOpen={setShowInActiveConfirmation}
          title={
            <div className="text-2xl font-bold text-secondary">
              {"Confirmation"}
              <div className="h-1 w-[30%] bg-secondary rounded-full" />
            </div>
          }
          saveText={
            selectedUser?.status?.toLowerCase() == "active"
              ? "Deactivate"
              : "Activate"
          }
          saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
          isLoading={isUpdateEmployeePending}
          onSave={onActivateDeactivateEmployee}
          contentClassName="!lg:w-[800px] lg:max-w-[800px]"
        >
          <div>
            Are you sure you want to deactivate this customer - {selectedUser?.fullName || ''}
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default Employee;
